import { gql } from "graphql-tag";
import { List } from "pages/dashboard/settings/list-utils";

type OrgListsQueryResult = {
  organization: {
    id: string;
    interestLists: List[];
  };
};

type SubscriptionListPayload = {
  data?: { settingsSidebarInterestListAdded?: List | null } | null;
};

export const SETTINGS_SIDEBAR_INTEREST_LIST_ADDED_SUBSCRIPTION = gql`
  subscription SettingsSidebarInterestListAdded {
    settingsSidebarInterestListAdded {
      id
      name
      property {
        id
        isDraft
      }
    }
  }
`;

/** Appends a new list to cached `getOrgLists` when not already present. */
export const mergeSettingsSidebarInterestListAddedIntoOrgLists = (
  prev: OrgListsQueryResult,
  subscriptionData: unknown,
): OrgListsQueryResult => {
  const payload = subscriptionData as SubscriptionListPayload | undefined;
  const next = payload?.data?.settingsSidebarInterestListAdded;
  if (!next?.id) {
    return prev;
  }

  const exists = prev.organization.interestLists.some((list) => list.id === next.id);
  if (exists) {
    return {
      ...prev,
      organization: {
        ...prev.organization,
        interestLists: prev.organization.interestLists.map((list) => (
          list.id === next.id ? { ...list, ...next } : list
        )),
      },
    };
  }

  const interestLists = [...prev.organization.interestLists, next].sort(
    (a, b) =>
      a.name.localeCompare(b.name, undefined, { sensitivity: "base" }) ?? 0,
  );

  return {
    ...prev,
    organization: {
      ...prev.organization,
      interestLists,
    },
  };
};
